// src/admin/views/CourseView.js
import React from 'react'
import '../../styles/admin.css'
import ConfirmationModal from '../components/ConfirmationModal'
import PageHeader from '../components/PageHeader'

function CourseView({
  courseData,
  handleChange,
  handleSubmit,
  handleDelete,
  handleCancel,
}) {
  const [showConfirmation, setShowConfirmation] = React.useState(false)

  return (
    <>
      <PageHeader pageName={'Course Info'} backTo="/admin/courses" />
      <div className="admin-card-container" style={{ maxWidth: '800px' }}>
        <div className="admin-card">
          <form onSubmit={handleSubmit}>
            <div className="admin-input-group">
              <label htmlFor="courseName" className="admin-label">
                Course Name
              </label>
              <input
                type="text"
                id="courseName"
                name="courseName"
                className="admin-input"
                value={courseData.courseName}
                onChange={handleChange}
                required
                placeholder="e.g. Augusta National"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div className="admin-input-group">
                <label htmlFor="rating" className="admin-label">
                  Course Rating
                </label>
                <input
                  type="number"
                  step="0.1"
                  id="rating"
                  name="rating"
                  className="admin-input"
                  value={courseData.rating}
                  onChange={handleChange}
                />
              </div>
              <div className="admin-input-group">
                <label htmlFor="slope" className="admin-label">
                  Course Slope
                </label>
                <input
                  type="number"
                  id="slope"
                  name="slope"
                  className="admin-input"
                  value={courseData.slope}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="admin-table-container">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Hole</th>
                    <th>Par</th>
                    <th>Hcp</th>
                    <th>Back</th>
                    <th>Mid</th>
                    <th>Fwd</th>
                    <th>Front</th>
                  </tr>
                </thead>
                <tbody>
                  {courseData.courseHoles.map((hole, index) => (
                    <tr key={index}>
                      <td style={{ fontWeight: '600', color: '#4a5568' }}>#{index + 1}</td>
                      <td>
                        <input
                          type="number"
                          name={`${index}-holePar`}
                          className="admin-table-input"
                          value={hole.holePar}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name={`${index}-holeHcp`}
                          className="admin-table-input"
                          value={hole.holeHcp}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name={`${index}-holeYdsA`}
                          className="admin-table-input"
                          value={hole.holeYdsA}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name={`${index}-holeYdsB`}
                          className="admin-table-input"
                          value={hole.holeYdsB}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name={`${index}-holeYdsC`}
                          className="admin-table-input"
                          value={hole.holeYdsC}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name={`${index}-holeYdsD`}
                          className="admin-table-input"
                          value={hole.holeYdsD}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="admin-button-group">
              {courseData?.courseId && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowConfirmation(true)}
                  style={{ marginRight: 'auto' }}
                >
                  Delete Course
                </button>
              )}
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save Course
              </button>
            </div>
          </form>
        </div>

        <ConfirmationModal
          questionText="Are you sure you want to delete this course? Doing so will delete all associated round data. Type DELETE to confirm."
          showConfirmation={showConfirmation}
          setShowConfirmation={setShowConfirmation}
          onConfirm={handleDelete}
        />
      </div>
    </>
  )
}

export default CourseView
